import React from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Spin, Col } from 'antd';
import { Formik } from 'formik';
import { Form, Input, Select } from 'formik-antd';
import { useTranslation } from 'react-i18next';
import Box from '~/components/Box';
import Button from '~/components/Button';
import FormControl from '~/components/Form/FormControl';
import Row from '~/components/Row';
import errorHandler from '~/Utils/errorHandler';

const style = {
  btnSubmit: { marginLeft: 10, marginRight: 10, marginTop: 25 },
  btnClear: { marginLeft: 'auto', marginTop: 25 },
};

export default function Filter({ isLoading, setFilters, projects }) {
  const { t } = useTranslation();
  const { Option } = Select;

  const handleSearch = values => {
    if (values.descriptionFilter === '0') {
      values.descriptionFilter = '';
    }

    const filter = [];
    try {
      if (
        values.descriptionFilter !== undefined &&
        values.descriptionFilter !== null &&
        values.descriptionFilter !== ''
      ) {
        filter.push({
          field: 'description',
          value: values.descriptionFilter,
          restriction: 'LIKE',
        });
      }
      if (
        values.projectsFilter !== undefined &&
        values.projectsFilter !== null &&
        values.projectsFilter !== '' &&
        values.projectsFilter !== 'All'
      ) {
        filter.push({
          columnJoin: 'project',
          field: 'id',
          value: values.projectsFilter,
          restriction: 'EQUAL',
        });
      }
      setFilters(filter);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <Box>
      <Formik
        initialValues={{ descriptionFilter: '', projects: projects, projectsFilter: 'All' }}
        enableReinitialize
        onSubmit={handleSearch}
      >
        {({ errors, resetForm }) => (
          <Spin spinning={isLoading}>
            <Form>
              <Row>
                <Col span="12">
                  <FormControl
                    error={errors.descriptionFilter}
                    field="descriptionFilter"
                    label={t('screens:closeout.subcontractor.description')}
                  >
                    <Input
                      name="descriptionFilter"
                      placeholder={t('fields:closeout.subcontractor.descriptionPlaceholder')}
                    />
                  </FormControl>
                </Col>
                <Col span="6">
                  <FormControl
                    field="projectsFilter"
                    label={t('screens:closeout.subcontractor.project')}
                    error={errors.project}
                  >
                    <Select name="projectsFilter">
                      <Option value="All">All</Option>
                      {projects?.map(item => {
                        return (
                          <Option key={item.id} value={item.id.toString()}>
                            {item.description}
                          </Option>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Col>
                <Button
                  color="default"
                  style={style.btnClear}
                  onClick={() => {
                    resetForm();
                    setFilters([]);
                  }}
                >
                  {t('screens:dateSearch.clearButton')}
                </Button>
                <Button type="submit" color="primary" style={style.btnSubmit}>
                  <SearchOutlined />
                  {t('screens:dateSearch.button')}
                </Button>
              </Row>
            </Form>
          </Spin>
        )}
      </Formik>
    </Box>
  );
}
